import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/jquery.easing.1.3.js';

$(document).ready(function() {
var $window = $(window);
var pos;

// mobile menu
var menuicon = $('header .menuicon'),
navBox = $('header .mmenu'),
nav = $('header .navBox'),
$body = $('body,html'),
headerbox = $('header');
$window.bind('scroll', function() {
    var scrollTop = $(this).scrollTop();
    pos = $window.scrollTop();
    var top = $('.rightbtn');
    if (scrollTop >= 47) {
        top.addClass('open');
        headerbox.addClass('navdown');
    } else{
        top.removeClass('open');
        headerbox.removeClass('navdown');
    }
    if($(window).scrollTop()>=$(document).height()-$(window).height() - 102){
        top.addClass('change');                     
    }else{
        top.removeClass('change');
    }
}).scroll();

$("#topBtn").click(function() {
    $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
    return false;
});

//mobile menu
var menuicon = $('header .menuicon'),
    navBox = $('header .mmenu'),
    nav = $('header .navBox'),
    $body = $('body,html');

    menuicon.on('click',function(){

        if(!$(this).hasClass('active')){
            $(this).addClass('active');
            //nav.removeClass('bgblack');
            navBox.stop().fadeIn();
            $body.css({'overflow':'hidden'}).addClass('menuopen');
        }else{
            $(this).removeClass('active');
            navBox.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''}).removeClass('menuopen');
            // if($('.indx').length > 0 && $(window).scrollTop() < 47){
            //    nav.addClass('bgblack');
            // }
        }
        return false;
    });
    $window.on('resize',function(){
        if($(window).width() < 992){
          
            $('.hasmenu').off('mouseenter mouseleave');
            $('a[data-menu]').off('click');
            $('a[data-menu]').on('click',function(){
                var $this = $(this);                
                if(!$this.hasClass('active')){
                    $this.addClass('active');
                    $this.next().slideDown(500);
                }else{
                    $this.removeClass('active');
                    $this.next().slideUp(500);
                }            
            });
        }else{
            $('a[data-menu]').removeClass('active');
            $('a[data-menu]').next().slideUp(500);
            menuicon.removeClass('active');
            navBox.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''}).removeClass('menuopen');

            $('a[data-menu]').off('click');
            $('.hasmenu').on('mouseenter',function(){
                var $this = $(this);
                $this.children('ul.subBox').stop().fadeIn(500);
            }).on('mouseleave',function(){
                var $this = $(this);
                $this.children('ul.subBox').stop().fadeOut(300, function() { 
                    $(this).removeAttr('style'); 
                });
            })
        }

        //top menu
        if($('#top-menu-ul').length > 0){
            var menu_ul = $('#top-menu-ul ul').width();
            var menu_box = $('#top-menu-ul').width()

            $('#top-menu-ul').removeClass('open_flexslider');
            $('#top-menu-ul .slides').removeAttr('style');
            $('#top-menu-ul .item_menu_Box').removeAttr('style');

          if(winW > 441 ){
              if(menu_ul > menu_box ){
                $('#top-menu-ul').addClass('open_flexslider'); 

              }
          }
          slider_ul_list();
        }
        
    }).resize();

    $('ul.subBox a').click(function(){
        var id = $(this).attr('href');
        
        if (id) {
            var t = $(id).offset().top;
            $('html, body').animate({scrollTop: t}, 1000)
        }
        if($(window).width() < 992){
            $('a[data-menu]').removeClass('active');
            $('a[data-menu]').next().slideUp(500);
            menuicon.removeClass('active');
            navBox.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''}).removeClass('menuopen');
        }
    })
    //faq
    $('[data-toggle]').on('click',function(){
        $(this).parent().siblings().find('.text-justify').slideUp();
        $(this).parent().siblings().removeClass('active');
        $(this).next().is(':hidden') ?  $(this).next().slideDown():$(this).next().slideUp();
        $(this).parent().hasClass('active') ? $(this).parent().removeClass('active') : $(this).parent().addClass('active');
        return false;
    })
});


var $window = $(window);
var winW = $window.width();
//menu scroll
function slider_ul_list() {

    var move = new Array();
    var total_width = 0;
    var i = 0;
    var sum = 0;
    var total = $("#top-menu-ul li");
    var active = $("#top-menu-ul .slides .active").index(); 
    total_width = $("#top-menu-ul ul").width();
    total.each(function(){
    move[i] = $(this).width();
    sum += move[i];
    i++;
    });
    sum = Math.round(( total_width - sum ) / i);
    for(var j=0;j<i;j++) move[j] += sum;
    sum = 0;
    
    for (var ac = 0; ac < active ; ac++) sum += move[ac];
    if(winW < 441){
      var topmenu_ul_active = $('#top-menu-ul li.active').offset();        
      $('#top-menu-ul .slides').scrollLeft(topmenu_ul_active.left - 30);
    }
    if($('#top-menu-ul').hasClass('open_flexslider')){
        var item_w = $("#top-menu-ul .item_menu_list").width();//ul 所有寬度
        var list_width = $('#top-menu-ul .item_Menu').width(); //按鈕最外層 940
        $('#top-menu-ul .item_menu_Box').css('width',item_w); //ul父層
       
        sum = sum > (total_width - list_width) ? (total_width - list_width) : sum;  
        //1200 - 940
        if(active > 0) $('#top-menu-ul .slides').stop().animate({left: sum*-1},0);
        console.log(sum)
        //click用
        var j = 0;
        var move_total = 0;
        for (var ac = 0; ac <= active ; ac++){
      move_total = ac > 0 ? (move_total + move[ac-1]) : 0;
         if(move_total > (total_width - list_width)) move_total = (total_width - list_width);
         else j = ac;
        }
        (ac - j) > 1 ? j++ : "";
  
        $("#top-menu-ul .flex-next").on('click',function(){
          if(move_total < (total_width - list_width)){
            $(this).removeClass('noright');
            j++;
            move_total = 0;
            for (var k = 0; k < j ; k++) move_total += move[k];
            move_total = move_total > (total_width - list_width) ? (total_width - list_width) : move_total; 
            if(j < i) $('#top-menu-ul .slides').stop().animate({left: move_total*-1},700);
           
          }else{
             $(this).addClass('noright');
          }
          return false;
        });
        $("#top-menu-ul .flex-prev").on('click',function() {
          if(move_total > 0){
            $(this).removeClass('noleft');
            j--;
            move_total = 0;
            for (var k = 0; k < j ; k++) move_total += move[k];
            move_total = move_total > (total_width - list_width) ? (total_width - list_width) : move_total;  
            if(j >= 0) $('#top-menu-ul .slides').stop().animate({left: move_total*-1},700);
         }else{
            $(this).addClass('noleft');
         }
         return false;
        });            
    }
  }